import React, { ChangeEventHandler, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import {
  ListItem,
  SignUpFormData,
} from "../../../../SignUpFormTypes/signUpFormTypes";
import InputWrapper from "../../Inputs/InputWrapper";
import FloatingLabelInput from "../../Inputs/FloatingLabelInput";
import { useSignUpForm } from "../../SignUpFormContext";
import SuggestionSelectOptions from "./SuggestionSelectOptions";

const OtherProfessionInput = () => {
  const { control, setValue } = useFormContext<SignUpFormData>();
  const { useOtherProfessionQuery } = useSignUpForm();
  const autoSuggestionList = useOtherProfessionQuery();
  const [showOptions, setShowOptions] = useState(false);
  const [suggestionsFound, setSuggestionsFound] = useState<ListItem[]>([]);

  const INPUT_NAME = "otherProfession";

  const findAndSetSuggestions: ChangeEventHandler<HTMLInputElement> = e => {
    const inputValue = e.currentTarget.value;

    if (!inputValue.trim()) return setShowOptions(false);

    const foundSuggestions = autoSuggestionList.filter(
      ({ autoSuggestionItem }) => {
        if (!autoSuggestionItem) return false;
        return autoSuggestionItem
          .toLowerCase()
          .includes(inputValue.toLowerCase());
      }
    );

    setSuggestionsFound(foundSuggestions);
    setShowOptions(foundSuggestions.length >= 1);
  };

  const handleOnChange =
    (hookChangeFunction: (...event: any[]) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const valueTrimmed = e.target.value.trim();
      hookChangeFunction(valueTrimmed === "" ? valueTrimmed : e.target.value);

      return findAndSetSuggestions(e);
    };

  return (
    <Controller
      name={INPUT_NAME}
      rules={signUpFormValidators.optional}
      control={control}
      render={({ field: { onChange, onBlur, ...field } }) => (
        <div className="flex flex-col gap-3 w-full">
          <InputWrapper
            errorMsg="Please enter a valid profession."
            label="Please specify"
            valid={false}
            valueExists={!!field.value}
            name={INPUT_NAME}
          >
            <FloatingLabelInput
              hasError={false}
              onChange={handleOnChange(onChange)}
              {...field}
            />
          </InputWrapper>
          {showOptions && (
            <SuggestionSelectOptions
              autoSuggestionList={suggestionsFound}
              setShowOptions={setShowOptions}
              setValue={setValue}
            />
          )}
        </div>
      )}
    />
  );
};

export default OtherProfessionInput;
